import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { RouteConfig } from 'vue-router'
import {
  constantRoutes,
  managerRouter,
  dashboardRouters,

  ITwaiterRouter,
  ITAllowAnyRoutes,
  ITadminRouter,

  LiveAllowAnyRoutes,
  LivewaiterRouter,
  LiveadminRouter,

  NetWorkAllowAnyRoutes,
  NetworkWaiterRouter,
  NetworkAdminRouter,

  AdministrationAllowAnyRoutes,
  AdministrationWaiterRouter,
  AdministrationAdminRouter,

  FuWuBaoZhangWaiterRouter,
  FuWuBaoZhangAdminRouter,
  FuWuBaoZhangAllowAnyRoutes,
  CaiGouGuanLiWaiterRouter,
  CaiGouGuanLiAdminRouter,
  CaiGouGuanLiAllowAnyRoutes,
  ShengChanGuanLiWaiterRouter,
  ShengChanGuanLiAdminRouter,
  ShengChanGuanLiAllowAnyRoutes,
  ShangPinYunYingWaiterRouter,
  ShangPinYunYingAdminRouter,
  ShangPinYunYingAllowAnyRoutes,
  GongYingGuanLiAdminRouter,
  GongYingGuanLiWaiterRouter,
  GongYingGuanLiAllowAnyRoutes
} from '@/router'
import { getRole, getuserCurrentAppName } from '@/utils/cookies'
import store from '@/store'
import {
  isItTicketType,
  isLiveType,
  isNetworkTicketType,
  isDashboardTicketType,
  isAdministrationTicketType,
  isFuWuBaoZhangTicketType,
  isCaiGouGuanLiTicketType,
  isShengChanGuanLiTicketType,
  isShangPinYunYingTicketType,
  isGongYingGuanLiTicketType
} from '@/utils/commonFunc'

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface IPermissionState {
  routes: RouteConfig[];
  dynamicRoutes: RouteConfig[];
}

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements IPermissionState {
  public routes: RouteConfig[] = []
  public dynamicRoutes: RouteConfig[] = []
  public firstAddFlag = true // 首次访问-需动态添加路由
  public firstRedirectFlag = false // 首次跳转
  public hasConstant = true

  @Mutation
  private SET_ROUTES(routes: RouteConfig[]) {
    /* 生成左侧导航菜单 */
    if (this.hasConstant) {
      routes = constantRoutes.concat(routes)
    }
    this.routes = routes
    this.dynamicRoutes = routes
  }

  @Mutation
  private SET_FIRST_FLAG(flag: boolean) {
    this.firstAddFlag = flag
  }

  @Mutation
  private SET_FIRST_REDIRECT_FLAG(flag: boolean) {
    this.firstRedirectFlag = flag
  }

  @Mutation
  private SET_HAS_CONSTANT_FLAG(flag: boolean) {
    this.hasConstant = flag
  }

  @Action
  public setFirstRedirectFlag(flag: boolean) {
    this.SET_FIRST_REDIRECT_FLAG(flag)
  }

  @Action
  public setFirstFlag(flag: boolean) {
    this.SET_FIRST_FLAG(flag)
  }

  @Action
  public setHasConstantFlag(flag: boolean) {
    this.SET_HAS_CONSTANT_FLAG(flag)
  }

  @Action
  public GenerateRoutes() {
    if (!this.firstAddFlag) return
    // 根据角色 生成新的路由表
    const ROLE = getRole()
    let roleRoutes: RouteConfig[] = []
    if (isItTicketType()) {
      // IT 权限
      switch (ROLE) {
        case '2':
          roleRoutes = ITwaiterRouter.concat(ITadminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '3':
          roleRoutes = ITwaiterRouter.concat(managerRouter).concat(ITadminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '4':
          roleRoutes = ITwaiterRouter.concat(managerRouter).concat(ITadminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[0].meta.icon = ''
          break
      }
      roleRoutes.unshift(...ITAllowAnyRoutes)
    } else if (isLiveType()) {
      // 直播保障权限
      switch (ROLE) {
        case '2':
          roleRoutes = LivewaiterRouter
          break
        case '3':
          roleRoutes = LivewaiterRouter.concat(managerRouter)
          break
        case '4':
          roleRoutes = LivewaiterRouter.concat(managerRouter).concat(LiveadminRouter)
          break
      }
      roleRoutes.unshift(...LiveAllowAnyRoutes)
    } else if (isNetworkTicketType()) {
      // 网络工单权限
      switch (ROLE) {
        case '2':
          roleRoutes = NetworkWaiterRouter
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[1].children[1].meta.hidden = true
          break
        case '3':
          roleRoutes = NetworkWaiterRouter.concat(managerRouter)
          break
        case '4':
          roleRoutes = NetworkWaiterRouter.concat(managerRouter).concat(NetworkAdminRouter)
      }
      roleRoutes.unshift(...NetWorkAllowAnyRoutes)
    } else if (isDashboardTicketType()) {
      // dashboard权限
      roleRoutes = dashboardRouters
      this.SET_HAS_CONSTANT_FLAG(false)
    } else if (isAdministrationTicketType()) {
      // 行政工单权限
      switch (ROLE) {
        case '2':
          roleRoutes = AdministrationWaiterRouter.concat(AdministrationAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '3':
          roleRoutes = AdministrationWaiterRouter.concat(managerRouter).concat(AdministrationAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '4':
          roleRoutes = AdministrationWaiterRouter.concat(managerRouter).concat(AdministrationAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[0].meta.icon = ''
          break
      }
      roleRoutes.unshift(...AdministrationAllowAnyRoutes)
    }else if (isFuWuBaoZhangTicketType()) {
      // 服务保障工单权限
      switch (ROLE) {
        case '2':
          roleRoutes = FuWuBaoZhangWaiterRouter.concat(FuWuBaoZhangAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '3':
          roleRoutes = FuWuBaoZhangWaiterRouter.concat(managerRouter).concat(FuWuBaoZhangAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '4':
          roleRoutes = FuWuBaoZhangWaiterRouter.concat(managerRouter).concat(FuWuBaoZhangAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[0].meta.icon = ''
          break
      }
      roleRoutes.unshift(...FuWuBaoZhangAllowAnyRoutes)
    } else if (isCaiGouGuanLiTicketType()) {
      // 服务保障工单权限
      switch (ROLE) {
        case '2':
          roleRoutes = CaiGouGuanLiWaiterRouter.concat(CaiGouGuanLiAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '3':
          roleRoutes = CaiGouGuanLiWaiterRouter.concat(managerRouter).concat(CaiGouGuanLiAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '4':
          roleRoutes = CaiGouGuanLiWaiterRouter.concat(managerRouter).concat(CaiGouGuanLiAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[0].meta.icon = ''
          break
      }
      roleRoutes.unshift(...CaiGouGuanLiAllowAnyRoutes)
    }else if (isShengChanGuanLiTicketType()) {
      // 生产管理工单权限
      switch (ROLE) {
        case '2':
          roleRoutes = ShengChanGuanLiWaiterRouter.concat(ShengChanGuanLiAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '3':
          roleRoutes = ShengChanGuanLiWaiterRouter.concat(managerRouter).concat(ShengChanGuanLiAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '4':
          roleRoutes = ShengChanGuanLiWaiterRouter.concat(managerRouter).concat(ShengChanGuanLiAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[0].meta.icon = ''
          break
      }
      roleRoutes.unshift(...ShengChanGuanLiAllowAnyRoutes)
    }else if (isShangPinYunYingTicketType()) {
      // 商品运营工单权限
      switch (ROLE) {
        case '2':
          roleRoutes = ShangPinYunYingWaiterRouter.concat(ShangPinYunYingAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '3':
          roleRoutes = ShangPinYunYingWaiterRouter.concat(managerRouter).concat(ShangPinYunYingAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '4':
          roleRoutes = ShangPinYunYingWaiterRouter.concat(managerRouter).concat(ShangPinYunYingAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[0].meta.icon = ''
          break
      }
      roleRoutes.unshift(...ShangPinYunYingAllowAnyRoutes)
    }else if (isGongYingGuanLiTicketType()) {
      // 商品运营工单权限
      switch (ROLE) {
        case '2':
          roleRoutes = GongYingGuanLiWaiterRouter.concat(GongYingGuanLiAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '3':
          roleRoutes = GongYingGuanLiWaiterRouter.concat(managerRouter).concat(GongYingGuanLiAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[1].meta.hidden = true
          break
        case '4':
          roleRoutes = GongYingGuanLiWaiterRouter.concat(managerRouter).concat(GongYingGuanLiAdminRouter)
          /* eslint-disable */
          /* tslint:disable */
          // @ts-ignore
          roleRoutes[roleRoutes.length - 1].children[0].meta.icon = ''
          break
      }
      roleRoutes.unshift(...GongYingGuanLiAllowAnyRoutes)
    }
    roleRoutes.push({ path: '*', redirect: '/404', meta: { hidden: true } }) // 全局404

    this.SET_ROUTES(roleRoutes)
    this.SET_FIRST_FLAG(false)
  }
}

export const PermissionModule = getModule(Permission)
